import React, { useEffect, useCallback } from "react";
import {
  FaTwitter,
  FaFacebook,
  FaPinterest,
  FaTelegramPlane,
} from "react-icons/fa";
import { GrClose } from "react-icons/gr";
import { IoLogoWhatsapp } from "react-icons/io";
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  TelegramShareButton,
} from "react-share";
import { CopyToClipboard } from "react-copy-to-clipboard";

export default function ShareLinksModal({
  title,
  shareUrl,
  shareLinksModal,
  setShareLinksModal,
}) {
  const handleScroll = useCallback(() => {
    if (shareLinksModal) {
      if (window.scrollY || window.scrollX) {
        setShareLinksModal(false);
      }
    }
  }, [shareLinksModal, setShareLinksModal]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll]);

  if (!shareLinksModal) return null;

  return (
    <>
      <div
        className="h-screen w-screen fixed z-20 flex justify-center align-center"
        aria-hidden
        style={{ backgroundColor: "rgba(39, 39, 39, 0.550)" }}
        onClick={() => setShareLinksModal(false)}
      />
      <div className="bg-white w-full bottom-0 lg:w-[450px] max-w-full  h-[240px] lg:h-[250px] flex flex-col fixed lg:top-1/2 lg:left-1/2 lg:transform lg:-translate-x-1/2 lg:-translate-y-1/2 z-50  py-6 px-4 mx-auto z-50 justify-between ">
        <div
          aria-hidden
          onClick={() => setShareLinksModal(false)}
          className="hover:bg-gray-300 focus:outline-0 p-[10px] rounded-full absolute flex items-center justify-center right-4 top-4 text-black text-xl cursor-pointer"
        >
          <GrClose className="" />
        </div>

        <h1 className="text-lg">{title}</h1>
        <ShareIconsBar shareUrl={shareUrl} />
        <div className="w-full flex flex-row border border-gray-200">
          <input value={shareUrl} className="w-full h-10 pl-1" readOnly />
          <CopyToClipboard text={shareUrl}>
            <button
              className="bg-gray-100 w-28 text-[14px] ripple"
              type="button"
            >
              Copy
            </button>
          </CopyToClipboard>
        </div>
      </div>
    </>
  );
}
function ShareIconsBar({ shareUrl }) {
  return (
    <div className="w-full flex justify-between py-3 md:justify-around">
      <div className="flex flex-col justify-center items-center">
        <WhatsappShareButton url={shareUrl}>
          <div className="p-3 md:p-4 rounded-full flex justify-center items-center bg-[#25D366]">
            <IoLogoWhatsapp className="text-white text-2xl" />
          </div>
        </WhatsappShareButton>
        <span className="text-[12px]">Whatsapp</span>
      </div>
      <TwitterShareButton url={shareUrl}>
        <div className="flex flex-col justify-center items-center">
          <div className="p-3 md:p-4 rounded-full flex justify-center items-center  bg-[#1DA1F2]">
            <FaTwitter className="text-white text-2xl" />
          </div>
          <span className="text-[12px]">Twitter</span>
        </div>
      </TwitterShareButton>

      <FacebookShareButton url={shareUrl}>
        <div className="flex flex-col justify-center items-center">
          <div className="p-3 md:p-4 rounded-full flex justify-center items-center  bg-[#4267B2]">
            <FaFacebook className="text-white text-2xl" />
          </div>
          <span className="text-[12px]">Facebook</span>
        </div>
      </FacebookShareButton>

      <div className="flex flex-col justify-center items-center">
        <a
          rel="noopener noreferrer"
          target="_blank"
          href={`http://pinterest.com/pin/create/link/?url=${shareUrl}`}
        >
          <div className="p-3 md:p-4 rounded-full flex justify-center items-center  bg-[#E60023]">
            <FaPinterest className="text-white text-2xl" />
          </div>
          <span className="text-[12px]">Pinterest</span>
        </a>
      </div>

      <TelegramShareButton url={shareUrl}>
        <div className="flex flex-col justify-center items-center">
          <div className="p-3 md:p-4 rounded-full flex justify-center items-center  bg-[#1DA1F2]">
            <FaTelegramPlane className="text-white text-2xl" />
          </div>
          <span className="text-[12px]">Telegram</span>
        </div>
      </TelegramShareButton>
    </div>
  );
}
